import React from 'react';
import { Card, Tag, Typography, Popconfirm, message, Button } from 'antd';
import { CalendarOutlined, UserOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { deletePost } from '../../api/localStorage';
import './index.css';

const { Meta } = Card;
const { Paragraph } = Typography;

const PostCard = ({ post, onPostDeleted }) => {
  const { id, title, author, date, tags, excerpt } = post;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/post/${id}`);
  };

  const handleDelete = () => {
    deletePost(id);
    message.success('文章删除成功！');
    if (onPostDeleted) {
      onPostDeleted(id); // 通知父组件更新文章列表
    }
  };

  const handleEdit = (e) => {
    e.stopPropagation(); // 阻止点击卡片跳转到详情页
    navigate(`/edit/${id}`); // 跳转到编辑页面
  };

  return (
    <Card
      className="post-card"
      hoverable
      onClick={handleClick}
      actions={[
        <Button key="edit" type="text" icon={<EditOutlined />} onClick={handleEdit}>编辑</Button>,
        <Popconfirm
          key="delete"
          title="确认删除"
          description="您确定要删除这篇文章吗？此操作不可撤销。"
          okText="确定"
          cancelText="取消"
          onConfirm={handleDelete}
        >
          <Button type="text" danger icon={<DeleteOutlined />}>删除</Button>
        </Popconfirm>
      ]}
    >
      <Meta
        title={title}
        description={
          <div className="post-meta">
            <div className="post-info">
              <span className="author">
                <UserOutlined /> {author}
              </span>
              <span className="date">
                <CalendarOutlined /> {date}
              </span>
            </div>
            <Paragraph ellipsis={{ rows: 3 }} className="post-excerpt">
              {excerpt}
            </Paragraph>
            <div className="tags">
              {tags.map((tag, index) => (
                <Tag color="blue" key={index}>{tag}</Tag>
              ))}
            </div>
          </div>
        }
      />
    </Card>
  );
};

export default PostCard;